import { Step, StepLabel, Stepper, styled, Tooltip } from "@mui/material";

const StyledStepIcon = styled("div")(({ ownerState }) => ({
    width: "100%",
    height: "12px",
    borderRadius: "1px",
    backgroundColor: ownerState.completed ? "#2C99D2" : "white",
    outline: `${ownerState?.active ? "3px" : "1px"} solid ${"#2C99D2"}`,
    position: "relative",
    zIndex: ownerState.active ? 1 : 0,
}));

const StyledStep = styled(Step)({
    width: "50px",
    padding: "0px",
    "& .MuiStepLabel-root": {
        padding: "0 0.5px 0 0.5px",
    },
    "& .MuiStepLabel-iconContainer": {
        width: "100%",
        padding: "0px",
    },
    justifyContent: "center",
});

const StyledStepLabel = styled(StepLabel)({
    "& .MuiStepLabel-label": {
        marginTop: "2px",
        color: "white",
        fontSize: "12px",
    },
    "&.MuiStepLabel-root": {
        flexGrow: 1,
    },
});

const StyledStepper = styled(Stepper)({
    display: "flex",
    "& .MuiStep-root": { backgroundColor: "transparent", display: "flex" },
    "& .MuiStepLabel-root": { backgroundColor: "transparent" },
    padding: "5px 0 5px 0",
    gap: "2px",
});

const StyledStepperContainer = styled("div")({
    padding: "5px 10px",
    minWidth: "530px",
    flex: 1,
    justifyContent: "center",
});

const StyledTooltipHeaderDiv = styled("div")({
    color: "white",
    margin: "10px 0 10px 0",
    fontWeight: 700,
    fontSize: "18px",
});

const StyledTooltipDescriptionDiv = styled("div")({
    color: "white",
    margin: "10px 0 10px 0",
    fontWeight: 300,
    fontSize: "12px",
    whiteSpace: "pre-wrap",
});

const StyledStatusDiv = styled("div")({
    color: "black",
    fontWeight: 300,
    fontSize: "13px",
    whiteSpace: "pre-wrap",
});

const StyledStatusHeaderDiv = styled("div")({
    color: "black",
    fontWeight: 700,
    fontSize: "13px",
    whiteSpace: "pre-wrap",
});

const CustomStepIcon = (props) => {
    const { active, completed, label, description } = props;
    return (
        <Tooltip title={CustomTooltipText(label, description)}>
            <StyledStepIcon ownerState={{ active, completed }} />
        </Tooltip>
    );
};

const CustomTooltipText = (headerText, bodyText) => {
    return (
        <div>
            <StyledTooltipHeaderDiv>{headerText}</StyledTooltipHeaderDiv>
            <StyledTooltipDescriptionDiv>{bodyText}</StyledTooltipDescriptionDiv>
        </div>
    );
};

const CustomStepper = (props) => {
    const { statusTracker } = props;

    const activeStep = statusTracker?.config?.activeStep;
    const labels = statusTracker?.config?.stepLabels;
    const descriptions = statusTracker?.config?.stepDescriptions;
    return (
        <StyledStepperContainer>
            <StyledStepper activeStep={activeStep} connector={null}>
                {labels.map((label, index) => {
                    return (
                        <StyledStep key={label}>
                            <StyledStepLabel
                                slots={{
                                    stepIcon: CustomStepIcon,
                                }}
                                slotProps={{
                                    stepIcon: { label, description: descriptions[index] },
                                }}
                            />
                        </StyledStep>
                    );
                })}
            </StyledStepper>
            <StyledStatusHeaderDiv>{labels[activeStep]}</StyledStatusHeaderDiv>
            <StyledStatusDiv>{descriptions[activeStep]}</StyledStatusDiv>
        </StyledStepperContainer>
    );
};

export default CustomStepper;
